
<span
    class="NavigationIndicator"
    ref="indicator"
    :class="{ 'is-mobile': isMobile }"
></span>
